(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("persistme", [], factory);
	else if(typeof exports === 'object')
		exports["persistme"] = factory();
	else
		root["persistme"] = factory();
})(window, function() {
return 